import { supabase } from '../lib/supabase';

/**
 * Records a sent email in the tracking table.
 * Called after successfully sending via Resend (emailId from response).
 */
export const recordEmailSent = async ({ userId, emailAddress, emailType, resendEmailId }) => {
  if (!userId || !emailAddress || !emailType) {
    return { success: false, error: 'Missing required fields' };
  }
  try {
    const { data, error } = await supabase
      ?.from('email_delivery_tracking')
      ?.insert({
        user_id: userId,
        email_address: emailAddress,
        email_type: emailType,
        resend_email_id: resendEmailId || null,
        status: 'in_transit',
        sent_at: new Date()?.toISOString()
      })
      ?.select()
      ?.single();

    if (error) throw error;
    return { success: true, data };
  } catch (err) {
    console.error('recordEmailSent error:', err);
    return { success: false, error: err?.message };
  }
};

/**
 * Fetches all email delivery tracking records for the current user.
 */
export const getEmailDeliveryHistory = async (userId) => {
  if (!userId) return { success: false, data: [], error: 'No user ID' };
  try {
    const { data, error } = await supabase
      ?.from('email_delivery_tracking')
      ?.select('*')
      ?.eq('user_id', userId)
      ?.order('sent_at', { ascending: false })
      ?.limit(50);

    if (error) throw error;
    return { success: true, data: data || [] };
  } catch (err) {
    console.error('getEmailDeliveryHistory error:', err);
    return { success: false, data: [], error: err?.message };
  }
};

/**
 * Manually refreshes status for a specific email by its resend ID.
 * Useful when webhook hasn't fired yet.
 */
export const refreshEmailStatus = async (trackingId) => {
  if (!trackingId) return { success: false, error: 'No tracking ID' };
  try {
    const { data, error } = await supabase
      ?.from('email_delivery_tracking')
      ?.select('*')
      ?.eq('id', trackingId)
      ?.single();

    if (error) throw error;
    return { success: true, data };
  } catch (err) {
    return { success: false, error: err?.message };
  }
};

export const emailTrackingService = {
  recordEmailSent,
  getEmailDeliveryHistory,
  refreshEmailStatus
};

export default emailTrackingService;
